import { display } from "@mui/system";
import styled from "styled-components";

export const Container = styled.div`
  padding: 30px 40px;
`;

export const Wrapper = styled.div`
  .action-wrapper {
    display: flex;
    align-items: center;
    gap: 17px;
    button {
      background: linear-gradient(
        180deg,
        #efefef 0%,
        rgba(255, 255, 255, 0) 100%
      );
      border: 1px solid #cdcfd0;
      border-radius: 100px;
      height: 40px;
      padding: 0 30px;
      font-weight: 500;
      font-size: 14px;
      line-height: 150.5%;
      &.active{
        background:#BC9B6A;
        color:#fff;
        border-color:#BC9B6A;
      }
    }
  }
`;
